import React, { useEffect, useState } from "react";
import { fetchFeedbacks } from "./api";

const FeedbackIndex = ({ isPageMode }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [page, setPage] = useState(1);
  const limit = isPageMode ? 10 : 5;
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchFeedbacks(page, limit);
      console.log("Data:", data);
      setFeedbacks(data?.feedbacks);
    };
    fetchData();
  }, [page]);
  Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + h * 60 * 60 * 1000);
    return this;
  };

  return (
    <div className="mt-4">
      <div className="is-flex is-justify-content-space-between">
        <h1 className="title is-5 has-text-center">
          Recent feedbacks {isPageMode && `(p. ${page})`}
        </h1>
        {isPageMode && (
          <div>
            {page > 1 && (
              <button
                onClick={() => {
                  setPage((prev) => prev - 1);
                }}
                className="button is-grey-dark">
                {"<"}
              </button>
            )}

            <button
              onClick={() => {
                setPage((prev) => prev + 1);
              }}
              className="button is-grey-dark ml-2">
              {">"}
            </button>
          </div>
        )}
      </div>
      {feedbacks?.map((feedback) => (
        <a href={`/feedbacks/${feedback._id}`} key={feedback.id}>
          <div className="card has-background-grey m-3" key={feedback.id}>
            <div className="card-content">
              <div className="is-flex is-justify-content-space-between">
                <p>
                  <small className="muted-text has-text-white">
                    {new Date(feedback.created_at)
                      .addHours(1)
                      .toLocaleDateString() +
                      " " +
                      new Date(feedback.created_at)
                        .addHours(1)
                        .toLocaleTimeString()}{" "}
                    -{" "}
                    <span className="tag is-secondary">
                      {feedback.is_premium ? "Premium User" : "Free User"}
                    </span>
                  </small>
                </p>
                <p
                  className={
                    !feedback.status || feedback.status === "Unhandled"
                      ? "tag muted-text is-danger ml-3"
                      : "tag muted-text is-light ml-3"
                  }>
                  <strong className="has-text-black">
                    {feedback.status ? feedback.status : "Unhandled"}
                  </strong>
                </p>
              </div>
              <p className="has-text-black subtitle">{feedback.content}</p>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default FeedbackIndex;
